import { render } from "./AppRouterButton.vue?vue&type=template&id=65fc7498&scoped=true"
import script from "./AppRouterButton.vue?vue&type=script&lang=js"
export * from "./AppRouterButton.vue?vue&type=script&lang=js"

import "./AppRouterButton.vue?vue&type=style&index=0&id=65fc7498&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fc7498"]])

export default __exports__